import { FormProvider, useForm } from 'react-hook-form';
import { FC, forwardRef, useImperativeHandle } from 'react';
import { FilterFormHandle, FilterTechMapProps } from '../filter-modal.types';
import { TechCardsFiltersNullableArg } from '@/entities/tables/tech-card';
import { assemblyTechMapDefaults } from '../../model/tech-map-defaults';
import { GroupSelect } from '../fields/group-select';
import { AssemblyNamingLazySelect } from '../fields/name-select';
import { CurrentOperationSelect } from '../fields/current-operation-select';
import { AssemblySymbolLazySelect } from '../fields/symbol-select';
import { CalendarRangePicker, TechCardStatuses, useResetForm } from '@/shared';
import { CheckboxGroupStatus } from '../fields/status-checkbox-group';
import styles from '../filter.module.scss';
import { WastedRadioGroup } from '../fields/wasted-radio-group';
import { CommentedRadioGroup } from '../fields/сommented-radio-group';

export const FilterAssemblyTechMap: FC<FilterTechMapProps> = forwardRef<FilterFormHandle, FilterTechMapProps>(
	({ defaultValue, onSubmit }, ref) => {
		const formProps = useForm<TechCardsFiltersNullableArg>({
			defaultValues: assemblyTechMapDefaults(defaultValue),
		});
		const { handleSubmit, setValue, getValues } = formProps;
		const { handleResetForm } = useResetForm(getValues, setValue);

		useImperativeHandle(ref, () => ({
			handleResetForm: () => {
				handleResetForm();
				setValue('createdAtFrom', null);
				setValue('createdAtTo', null);
				setValue('storageAtFrom', null);
				setValue('storageAtTo', null);
				handleSubmit(onSubmit)();
			},
			requestSubmit() {
				handleSubmit(onSubmit)();
			},
		}));

		const selectCreatedDates = (firstDate: string, secondDate: string) => {
			setValue('createdAtFrom', firstDate);
			setValue('createdAtTo', secondDate);
		};
		const selectSGDDates = (firstDate: string, secondDate: string) => {
			setValue('storageAtFrom', firstDate);
			setValue('storageAtTo', secondDate);
		};

		return (
			<form className={styles['form']} onSubmit={handleSubmit(onSubmit)}>
				<FormProvider {...formProps}>
					<GroupSelect />
					<AssemblyNamingLazySelect />
					<CurrentOperationSelect />
					<AssemblySymbolLazySelect />
					<CheckboxGroupStatus
						statuses={[
							TechCardStatuses.progress,
							TechCardStatuses.accepted_at_sgd,
							TechCardStatuses.partially_issued,
							TechCardStatuses.canceled,
							TechCardStatuses.released,
						]}
					/>
					<WastedRadioGroup />
					<CommentedRadioGroup />
					<CalendarRangePicker
						textLabel="Дата создания"
						setDates={selectCreatedDates}
						defaultValue={{
							from: defaultValue?.createdAtFrom,
							to: defaultValue?.createdAtTo,
						}}
					/>
					<CalendarRangePicker
						textLabel="Дата принятия на СГД"
						setDates={selectSGDDates}
						defaultValue={{
							from: defaultValue?.storageAtFrom,
							to: defaultValue?.storageAtTo,
						}}
					/>
				</FormProvider>
			</form>
		);
	},
);
